import { createContext, PropsWithChildren, useContext } from 'react';

const PolicystreamContext = createContext<boolean>(false);

interface PolicyStreamProviderProps extends PropsWithChildren<{}> {}
export const PolicyStreamProvider = ({
  children,
}: PolicyStreamProviderProps) => {
  return (
    <PolicystreamContext.Provider value={true}>
      {children}
    </PolicystreamContext.Provider>
  );
};

export const useInPolicystream = () => {
  return useContext(PolicystreamContext);
};
